import { Injectable } from '@angular/core';
import { HttpServiceService } from './../../../common-service/http-service.service';
import { insadminUrl } from '../../models/insadmin/insadmin.model';
import { ServerURLService } from 'src/app/common-service/serverURL.service';
import { encryptionService } from 'src/app/common-service/cedService';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class InsadminService {
  
  

  constructor(public url: insadminUrl, public http: HttpServiceService, public serverURL: ServerURLService, public ced: encryptionService) { }
  // All Inspectors
  getAllInspectionWithPage(inspectionType: any) {
    return this.http.post(this.url.getAllInspectionWithPage ,inspectionType );
  }

  //save countrymaster added by gokul
  saveInspectionMaster(Inspectionobj: any) {
    return this.http.post(this.url.saveInspectionMaster, Inspectionobj);
  }

  inspectionDetailsById(inspectionMstrId: number)
  {
    const inspectiontypeIdEncr = encodeURIComponent(this.ced.encryptAesToString(inspectionMstrId, this.serverURL.secretKey).toString());
    return this.http.get(this.url.InspectionDetailsById + '?inspectionIdEncr=' + inspectiontypeIdEncr); 
  }
  getallInsp(searchWord: any, page: number, rows: number) {
    return this.http.get(this.url.getAllInspectors + '?searchWord=' + searchWord + '&page=' + page + '&rows=' + rows);
  }
  getInsByStatus(status: any, page: number, rows: number) {
    return this.http.get(this.url.getInsByStatus + '?status=' + status + '&page=' + page + '&rows=' + rows);
  }
  getAllInsTypeWithPage(insSubTypeSearchCriteria:any)
  {
    return this.http.post(this.url.getAllInsTypeWithPage,insSubTypeSearchCriteria );
  }
  getAllInsPurposeWithPage(insPurposeSearchCriteria:any)
  {
    return this.http.post(this.url.getAllInsPurposeWithPage,insPurposeSearchCriteria );
  }

getstates() {
    return this.http.get(this.url.states);
  }
  getcollbystate(name: any) {
    return this.http.get(this.url.getcollBystate + '?stateName=' + name);
  }
  getcollspecilization(id: any) {
    return this.http.get(this.url.collegeSpecilization + '?collegeId=' + id);
  }
  getColegeStaff(collegeId: any, specialisationId: any) {
    return this.http.get(this.url.collegeStaff + '?collegeId=' + collegeId + '&specialisationId=' + specialisationId);
  }
  getInspectorDetails(datas: any) {
    // by gokul
    // let idObj = { 
    //   'inspectorId': id
    // }
    return this.http.post(this.url.getInspectorDetails, datas);
    //return this.http.get(this.url.getInspectorDetails + '?inspectorId=' + id)
  }

  getInspectorDetailsview(datas: any) {
    // by gokul
    // let idObj = { 
    //   'inspectorId': id
    // }
    return this.http.post(this.url.getInspectorDetailsview, datas);
    //return this.http.get(this.url.getInspectorDetails + '?inspectorId=' + id)
  }

  // Inspection Shedulers
  shedulingStates() {
    return this.http.get(this.url.shedulingStates);
  }
  getCitybyState(id: any) {
    return this.http.get(this.url.cityByStates + '?stateName=' + id)
  }
  getcollegeList(stateId: any, collegeId: any) {
    return this.http.get(this.url.colegeList + '?stateId=' + stateId + '&collegeId=' + collegeId)
  }
  allInspetypes() {
    return this.http.get(this.url.allInspetypes);
  }

  allInsptypes(sectionId: number) {
    return this.http.get(this.url.allInsptypes + '?sectionId=' + sectionId);
  }
  inspeCourseSubtype(inspectionTypeId: any) {
    return this.http.get(this.url.inspeCourseSubtype + '?inspectionTypeId=' + inspectionTypeId);
  }
  inspeCoursetype(insTypeId: any, insSubTypeId: any) {
    return this.http.get(this.url.inspeCoursetype + '?inspectionTypeId=' + insTypeId + '&inspectionSubTypeId=' + insSubTypeId);
  }
  inspeCoursePurpo(instypeid: any, insSubtypeid: any, inspectionPurposeId: any) {
    return this.http.get(this.url.inspeCoursePurpo + '?inspectionTypeId=' + instypeid +
      '&inspectionSubTypeId=' + insSubtypeid + '&inspectionPurposeId=' + inspectionPurposeId);
  }
  insgetallCourses(){
    return this.http.get(this.url.insAllCourses) 
  }
  saveInsType(insTypeobj: any)
  {
    return this.http.post(this.url.saveInsType, insTypeobj);
  }
  saveInspectionPurpose(inspectionPurposeobj: any)
  {
    return this.http.post(this.url.saveInspectionPurpose, inspectionPurposeobj);
  }


  insSubTypeDetailsById(insTypeId: number)
  {
    const insTypeIdEncr = encodeURIComponent(this.ced.encryptAesToString(insTypeId, this.serverURL.secretKey).toString());
    return this.http.get(this.url.insSubTypeDetailsById + '?inspectionSubTypeIdEncr=' + insTypeIdEncr); 
  }

  inspectionPurposeDetailsById(insPurposeId: number)
  {
    const insPurposeIdEncr = encodeURIComponent(this.ced.encryptAesToString(insPurposeId, this.serverURL.secretKey).toString());
    return this.http.get(this.url.inspectionPurposeDetailsById + '?inspectionPurposeIdEncr=' + insPurposeIdEncr); 
  }


// getSpecializationsByCourseId
getSpecializations(courseId: any, entityMasterId: any) {
  return this.http.get(this.url.getSpecialisationByCourseId + '?courseId=' + courseId + '&entityMasterId=' + entityMasterId);
}
  inspePurpoCourse(instypeid: any, insSubtypeid: any, inspectionPurposeId: any, courseId: any) {
    return this.http.get(this.url.inspePurpoCourse + '?inspectionTypeId=' + instypeid +
      '&inspectionSubTypeId=' + insSubtypeid + '&inspectionPurposeId=' + inspectionPurposeId + '&courseId=' + courseId);
  }
  getPermittedSeats(collegeId: any, specilizationId: any) {
    return this.http.get(this.url.permittedSeats + '?collegeId=' + collegeId + '&specialisationId=' + specilizationId);
  }

  // Shedules
  getallShedules(page: number, rows: number) {
    return this.http.get(this.url.getallShedule + '?page=' + page + '&rows=' + rows);
  }

  getallCancelledShedules(page: number, rows: number) {
    return this.http.get(this.url.getallCancelledShedules + '?page=' + page + '&rows=' + rows);
  }

  getallCompletedShedules(page: number, rows: number) {
    return this.http.get(this.url.getallCompletedShedules + '?page=' + page + '&rows=' + rows);
  }
  InitiateDetails(id: any) {
    // by gokul
    
    return this.http.get(this.url.InitiateDetails +'?inspectionId=' +id );

  }
  getSheduleDetails(data:any) {
     //by gokul
    return this.http.post(this.url.getSheduleDetails, data);
    //return this.http.get(this.url.getSheduleDetails +'?inspectionId=' +id );

  }

  // Post Calls
  addingInspector(data: any) {
    return this.http.post(this.url.addingInspector, data);
  }
  // saveInspection(data: any) {
  //   return this.http.post(this.url.saveSheduleInspe, data);
  // }

  // post Call
  saveInspection(filearray, obj: any) {
    var formdata = new FormData();
    for (let i = 0; i < filearray.length; i++) {
      formdata.append('files', filearray[i].files);
    }
    formdata.append('scheduleInspection', JSON.stringify(obj));
    return this.http.post(this.url.saveSheduleInspe, formdata);
  }

  // resheduleInspection(data: any , filearray : any) {
  //   const formdata = new FormData();
  //   for (let i = 0; i < filearray.length; i++) {
  //         formdata.append('files', filearray[i]);
  //       }
  //   return this.http.post(this.url.resheduleInspection + '?inspectionId=' + data.inspectionId
  //     + '&fromDate=' + data.fromdate + '&toDate=' + data.toDate ,formdata);
  // }


  // resheduleInspection(data: any, filearray : any) {
  //   const formdata = new FormData();
  //   for (let i = 0; i < filearray.length; i++) {
  //     formdata.append('files', filearray[i]);
  //   }
  //   formdata.append('inspectionId',data.inspectionId);
  //   formdata.append('noOfInspDays', data.noOfInspDays);
  //    formdata.append('inspectionDate', data.inspectionDate);
  //   formdata.append('fromDate', data.fromdate);
  //   formdata.append('toDate', data.toDate);
  
  //   return this.http.post(this.url.resheduleInspection, formdata);
  // }
// resheduleInspection(data: any, filearray : any) {
//     const formdata = new FormData();
//     for (let i = 0; i < filearray.length; i++) {
//       formdata.append('files', filearray[i]);
//     }
//     formdata.append('inspectionId',data.inspectionId);
//     formdata.append('noOfInspDays', data.noOfInspDays);
//       formdata.append('inspectionDate', data.inspectionDate);
//     formdata.append('fromDate', data.fromdate);
//     formdata.append('toDate', data.toDate);
  
//     return this.http.post(this.url.resheduleInspection, formdata);
//   }

resheduleInspection(data: any, filearray: any) {

  const formdata = new FormData();

  if (filearray && filearray.length > 0) {
    for (let i = 0; i < filearray.length; i++) {
      formdata.append('files', filearray[i]);
    }
  }

  formdata.append('inspectionId', String(data.inspectionId));

  if (data.noOfInspDays != null) {
    formdata.append('noOfInspDays', String(data.noOfInspDays));
  }

  if (data.inspectionDate) {
    formdata.append('inspectionDate', data.inspectionDate);
  }

  if (data.fromdate) {
    formdata.append('fromDate', data.fromdate);
  }

  if (data.toDate) {
    formdata.append('toDate', data.toDate);
  }

  return this.http.post(this.url.resheduleInspection, formdata);
}
  resendAccMail(inspectionId: any) {
    const obj = {
      inspectionId: this.ced.encryptAesToString(inspectionId, this.serverURL.secretKey).toString(),
    }
    return this.http.post(this.url.resendAccMail, obj);
  }
  
  searchShedule(stateId: any, collegeId: any,searchId: any, page: number, rows: number) {
    return this.http.get(this.url.searchgetallShedule + '?stateName=' + stateId + '&collegeId=' + collegeId + '&searchId=' + searchId+ '&page=' + page + '&rows=' + rows);
  }

  getReportsList(fromDate: any, toDate: any,stateId: any, collegeId: any,page: number, rows: number) {
    return this.http
      .get(this.url.reportList + '?fromScheduleDate=' + fromDate + '&toScheduleDate=' + toDate + '&stateId=' + stateId + '&collegeId=' + collegeId 
        + '&page=' + page + '&rows=' + rows);
  }

  // put Call 
  deletedIsnpector(obj: any) {
    return this.http.post(this.url.removeInspector, obj);
  }
  
  cancelShedule(id: any, filearray:any,reason:any) {
    const formdata = new FormData();
    for (let i = 0; i < filearray.length; i++) {
      formdata.append('files', filearray[i]);
    }
    formdata.append('inspectionId', id);
    formdata.append('cancelComments', reason);

    return this.http.post(this.url.cancelInspection, formdata);
  }

  reassign(inspectionId: any, inspectorId: any) {
    return this.http.update(this.url.reassign + '?inspectionId=' + inspectionId + '&inspectorId=' + inspectorId, 'data');
  }

  inspectionclose(data: any) {
    return this.http.update(this.url.inspectionclose, data);
  }

  acceptinspectionscehdule(paramsId: any, paramsinspectorId: any, status: any, remarks: any) {
    //by gokul
    let idObj = { 
       'inspectionId': paramsId,
       'inspectorId' : paramsinspectorId,
       'status': status,
       'remarks': remarks
    }
    return this.http.post(this.url.acceptinspectionUser ,idObj)
  //  return this.http.get(this.url.acceptinspectionUser + '?inspectionId=' + paramsId + '&inspectorId=' + paramsinspectorId + '&status=' + status + '&remarks=' + remarks);
  }

  getProformaDetails(id : any){
    return this.http.get(this.url.getProformaDetails +'?inspectionId=' + id);
  }

  //put calls added by gokul
  sendforchangecompletedstatus(inspectionEncryptDTO: any, filearray : any) {
    const formdata = new FormData();
    for (let i = 0; i < filearray.length; i++) {
      formdata.append('files', filearray[i]);
    }
    formdata.append('inspectionId', inspectionEncryptDTO.inspectionId);
    formdata.append('comments', inspectionEncryptDTO.comments);
    formdata.append('roleName', inspectionEncryptDTO.roleName);
    return this.http.post(this.url.sendforchangecompletedstatus, formdata);
  }

  cancelinspectionfrominceptor(paramsId: any,insceptorid: any,changestatusComments: any) {
    return this.http.update(this.url.cancelinspectionfrominceptor + '?inspectionId=' + paramsId + '&inspectorId=' + insceptorid + '&remarks=' + changestatusComments, '');
  }

  dciLetterExportPDFInspector() {
    return this.http.get(this.url.dciLetterExportPDFInspector + '?inspectionId=' + 650);
  }

  getAllInspectorMasterWithPage(inspectorSearchCriteria: any) {
    return this.http.post(this.url.getAllInspectorsWithPage, inspectorSearchCriteria);
  }
  getAllInspectorUtilizationWithPage(inspectorSearchCriteria: any) {
    return this.http.post(this.url.getAllInspectorsUtilWithPage, inspectorSearchCriteria);
  }
  getAvailableInspectorsDtls(inspectorSearchCriteria: any) {
    return this.http.post(this.url.getAvailableInspectorsDtls, inspectorSearchCriteria);
  }
  getExaustedInspectorsDtls(inspectorSearchCriteria: any) {
    return this.http.post(this.url.getExaustedInspectorsDtls, inspectorSearchCriteria);
  }
  // Inspector Export Excel
  inspectorExportExcel(obj: any) {
    return this.http.post(this.url.inspectorExportExcel, obj);
  }
  // Inspector Utilization Excel 
  inspectorUtilizationExportExcel(obj: any) {
    return this.http.post(this.url.inspectorUtilizationExportExcel, obj);
  }
  avalInspectorExportExcel(obj: any) {
    return this.http.post(this.url.avalInspectorExportExcel, obj);
  }
  getInspectionList(obj: any) {
    return this.http.post(this.url.getInspectionList, obj);
  }

   getnewInspectionList(obj: any) {
    return this.http.post(this.url.getnewInspectionList, obj);
  }
  getAppointedInspectorsList(obj: any) {
    return this.http.post(this.url.getAppointedInspectorsList, obj);
  }
  inspectionListExportPDF(obj: any) {
    return this.http.post(this.url.inspectionListExportPdf, obj);
  }
  appointedInspectorListExportPDF(obj: any) {
    return this.http.post(this.url.appointedInspectorListExportPDF, obj);
  }
  appointedInspectorListExportExcel(obj: any) {
    return this.http.post(this.url.appointedInspectorListExportExcel, obj);
  }
  inspectionListExportExcel(obj: any) {
    return this.http.post(this.url.inspectionListExportExcel, obj);
  }
  getTrackInspectionList(obj: any) {
    return this.http.post(this.url.getTrackInspectionList, obj);
  }
 getnewTrackInspectionList(obj: any) {
    return this.http.post(this.url.getnewTrackInspectionList, obj);
  }
  getInspectionProcessHistory(inspectionId: any, sort: string) {
    const obj = {
      inspectionId: this.ced.encryptAesToString(inspectionId, this.serverURL.secretKey).toString(),
      sort: sort,
      roleName: this.ced.encryptAesToString(sessionStorage.getItem('selectedRole-usec'), this.serverURL.secretKey).toString()
    }
    return this.http.post(this.url.getInspectionProcessHistory, obj);
  }

  approveInspectionScheduler(data: any) {
    return this.http.post(this.url.approveInspectionScheduler, data);
  }

   approveInspection(data: any) {
    return this.http.post(this.url.approveInspection, data);
  }
  testOneDayPriorEmail() {
    return this.http.get(this.url.testOneDayPriorEmail);
  }

  saveOauthDetailsInspector() {
    return this.http.get(this.url.saveOauthDetailsInspector);
  }

  getTrackInspectionStatusList() {
    const obj = {
      roleName: this.ced.encryptAesToString(sessionStorage.getItem('selectedRole-usec'), this.serverURL.secretKey).toString()
    }
    return this.http.post(this.url.getTrackInspectionStatusList, obj);
  }

  getnewTrackInspectionStatusList() {
    const obj = {
      roleName: this.ced.encryptAesToString(sessionStorage.getItem('selectedRole-usec'), this.serverURL.secretKey).toString()
    }
    return this.http.post(this.url.getnewTrackInspectionStatusList, obj);
  }

  // Preview pdf
  previewOfficeOrder(inspectionId: number, inspectorId: number){
    const obj = {
      inspectionId: this.ced.encryptAesToString(inspectionId, this.serverURL.secretKey).toString(),
      inspectorId: this.ced.encryptAesToString(inspectorId, this.serverURL.secretKey).toString(),
    }
    return this.http.post(this.url.previewOfficeOrder, obj);
  }

  // delete Document
  deleteInspDocument(documentId:any){
    return this.http.delete(this.url.deleteInspDocument+'?documentId='+documentId);
  }

  //Delete Inspection  
deleteInspection(inspectionId:any){
  return this.http.delete(this.url.deleteInspection + '?inspectionId=' + inspectionId);
}

  inspectorCancelInspectionSection(data: any) {
    return this.http.post(this.url.inspectorCancelInspectionSection, data);
  }
  inspectorCancelManualInspectionSection(data: any){
    return this.http.post(this.url.inspectorCancelManulaInspectionSection, data);
  }

  manualInspectorSelection(obj,filearray,remarks) {
    // const formData: FormData = new FormData();
    // formData.append('inspectionId', inspectionId);
    // formData.append('inspectorIdList', inspectorIdList);
    let inspectorIds = "";
    for(let i=0;i<obj.inspectorIdList.length;i++){
      if(i==0){
        inspectorIds += obj.inspectorIdList[i];
      }else{
        inspectorIds += "," + obj.inspectorIdList[i];
      }
       
    }
    const formdata = new FormData();
    for (let i = 0; i < filearray.length; i++) {
      formdata.append('files', filearray[i]);
    }
   // formdata.append('inspectionId', id);
    formdata.append('inspectorIds', inspectorIds);
    formdata.append('remarks',remarks.value);
    formdata.append('inspectionId',obj.inspectionId);

 //   return this.http.post(this.url.cancelInspection, formdata);
    return this.http.post(this.url.manualInspectorSelection, formdata);
  }

  getInspectionHolidayList(obj: any) {
    return this.http.post(this.url.getInspectionHolidayList, obj);
  }

  getInspectionCollegeHolidayList(obj: any) {
    return this.http.post(this.url.getInspectionCollegeHolidayList, obj);
  }

  // getInspectionHolidayListWithState(stateName: any) {
  //   const url = `${this.url.getInspectionHolidayListWithState}?stateName=${stateName}`;
  //   return this.http.get(url);
  // }
  getInspectionHolidayListWithState(stateName: string, collegeName: string) { 
    const url = `${this.url.getInspectionHolidayListWithState}?stateName=${encodeURIComponent(stateName)}&collegeName=${encodeURIComponent(collegeName)}`;
    return this.http.get(url);
  }
  
  saveInspectionHoliday(holidayInfo: any) {
    return this.http.post(this.url.saveInspectionHolidayMaster, holidayInfo);
  }

  saveInspectionCollegeHoliday(holidayViewInfo: any) {
    return this.http.post(this.url.saveInspectionCollegeHolidayMaster, holidayViewInfo);
  }
  
  saveInspectionCollegeHolidayfromDate(holidayInfo: any) {
    return this.http.post(this.url.saveInspectionCollegeHolidayMasterFromDate, holidayInfo);
  }

  getInspectionHolidayById(obj: any) {
    return this.http.post(this.url.getInspHolidayById, obj);
  }

  getInspectioncollegeHolidayById(obj: any) {
    return this.http.post(this.url.getInspcollegeHolidayById, obj);
  }

  deleteInspectionHolidayById(obj: any) {
    return this.http.post(this.url.deleteInspHolidayById, obj);
  }

  deleteCollegeInspectionHolidayById(obj: any) {
    return this.http.post(this.url.deleteInspCollegeHolidayById, obj);
  }

  importExcelHolidayMstr(file: any) {
    const formData: FormData = new FormData();
    formData.append('file', file[0]);

    return this.http.post(this.url.importExcelHolidayMstr, formData);
  }

  importCollegeExcelHolidayMstr(file: any) {
    const formData: FormData = new FormData();
    formData.append('file', file[0]);

    return this.http.post(this.url.importCollegeExcelHolidayMstr, formData);
  }
 

  resendMailandSMSBasedOnTheStatus(inspStatus,inspRefId){
    return this.http.get(this.url.resendMailandSMSBasedOnTheStatus + '?inspStatus=' + inspStatus + '&inspRefId=' + inspRefId);
  }

  generateOfficeOrder(inspectionId: any) {
    const obj = {
      inspectionId: this.ced.encryptAesToString(inspectionId, this.serverURL.secretKey).toString(),
    }
    return this.http.post(this.url.generateOfficeOrder, obj);
  }
  resentTravelDeskMail( inspectionId: any) { 
    const parsedInspectionId = parseInt(inspectionId); 

    return this.http.get(this.url.resentTravelDesk + '?inspectionId=' +  parsedInspectionId );
}
}
